import { createContext, type Dispatch } from "react";
import { defaultState } from "./Store";
import { type State, AuthenticationAction } from "./types";

export const AuthenticationContext = createContext<State>(defaultState);
export const AuthenticationDispatchContext = createContext<Dispatch<AuthenticationAction>>(() => {});
